<template>
  <div>
    <div class="border">
      <div id="echartsV" class="echarts" />
    </div>
    <div class="border mt-30">
      <div id="echartsE" class="echarts" />
    </div>
    <div class="border mt-30">
      <div id="echartsT" class="echarts" />
    </div>
  </div>
</template>

<script>
import { getYMDHMS } from "@/utils/date";
export default {
  props: {
    delay: {
      type: Number,
      default() {
        return 5000;
      },
    },
    orderNum: {
      type: String,
      default() {
        return "";
      },
    },
  },
  data() {
    return {
      // echartsVSource: [
      //   ['product', '2012', '2013', '2014', '2015', '2016', '2017'],
      //   ['需求电压', 41.1, 30.4, 65.1, 53.3, 83.8, 98.7],
      //   ['实际电压', 86.5, 92.1, 85.7, 83.1, 73.4, 55.1]
      // ],
      echartsVSource: [], // 电压的数据
      echartsESource: [], // 电流的数据
      echartsTSource: [], // 枪线温度的数据
      pageNo: 1,
      timestamp: "", // 当前请求完接口的时间戳
      echartsTimer: "", // 全局定时器
      // 只有直流桩才有两条线，后续要做交流桩只有一条线的处理
      type: 2, // 1是交流，2是直流




      num: "",
      Vxdata: [],
      Vydata1: [],
      Vydata2: [],
      Exdata: [],
      Eydata1: [],
      Eydata2: [],
      Txdata: [],
      Tydata: [],
    };
  },
  beforeMount() {
    this.num = this.$route.query.num
  },
  mounted() {
    this.getFirstData();
    
  },
  // 页面销毁时清除定时器
  beforeDestroy() {
    clearInterval(this.echartsTimer);
  },
  methods: {
    // 第一次获取当前订单数据，直接请求所有的数据，每次请求接口记录一下当前的时间，然后再加
    getFirstData() {
      // const data = {
      //   pageSize: 2147483647,
      //   pageNo: 1,
      //   msgType: 17,
      //   orderNo: this.orderNum ? this.orderNum : this.$route.query.num,
      //   orderType: 1
      // }
      this.$store.dispatch("form/handle", {
        url:
          "/msglog/messageLog/realTimeDataMap/voltage?startChargeSeq=" + this.num,
        method: "get",
        // data: data,
        // data1: true,
        callback: (resp) => {
          resp.forEach((item) => {
            this.Vxdata.push(item.time)
            this.Vydata1.push(item.voltageReq)
            this.Vydata2.push(item.voltageOutPut)
            // console.log(item.voltageReq, 12345); //需求
            // console.log(item.voltageOutPut, 12345); //实际
          });
          this.echartsV();

          // 1为交流2为直流，只有直流桩才有两条线，后续要做交流桩只有一条线的处理
          // this.type = resp.type || 2
          // let data = null
          // // 如果为2则是直流
          // if (this.type === 2) {
          //   data = this.getDirectData(resp)
          //   data.time.unshift('product')
          //   data.demandVoltage.unshift('需求电压')
          //   data.currentVoltage.unshift('实际电压')
          //   data.demandEleCurrent.unshift('需求电流')
          //   data.currentEleCurrent.unshift('实际电流')
          //   data.gunLineTem.unshift('枪线温度')
          //   // 对三个图表赋值
          //   this.echartsVSource = [JSON.parse(JSON.stringify(data.time)), JSON.parse(JSON.stringify(data
          //     .demandVoltage)), JSON.parse(JSON.stringify(data.currentVoltage))]
          //   this.echartsESource = [JSON.parse(JSON.stringify(data.time)), JSON.parse(JSON.stringify(data
          //     .demandEleCurrent)), JSON.parse(JSON.stringify(data.currentEleCurrent))]
          //   this.echartsTSource = [JSON.parse(JSON.stringify(data.time)), JSON.parse(JSON.stringify(data
          //     .gunLineTem))]
          // } else {
          //   data = this.getInterflowData(resp)
          //   data.time.unshift('product')
          //   data.demandVoltage.unshift('输出电压')
          //   data.demandEleCurrent.unshift('输出电流')
          //   data.gunLineTem.unshift('枪线温度')
          //   // 对三个图表赋值
          //   this.echartsVSource = [JSON.parse(JSON.stringify(data.time)), JSON.parse(JSON.stringify(data
          //     .demandVoltage))]
          //   this.echartsESource = [JSON.parse(JSON.stringify(data.time)), JSON.parse(JSON.stringify(data
          //     .demandEleCurrent))]
          //   this.echartsTSource = [JSON.parse(JSON.stringify(data.time)), JSON.parse(JSON.stringify(data
          //     .gunLineTem))]
          // }
          // // 如果有数据的话就给个当前时间戳
          // this.timestamp = resp.list.length ? getYMDHMS(new Date().getTime()) : ''
          // this.echartsV()
          // this.echartsE()
          // this.echartsT()
          // // 第一次数据不为空
          // if (this.timestamp !== '' && this.timestamp) {
          //   if (this.delay) {
          //     this.echartsTimer = setInterval(() => {
          //       if (this.timestamp !== '' && this.timestamp) {
          //         this.pageNo = this.pageNo + 1
          //         this.getSecondData(this)
          //       } else {
          //         this.timestamp = resp.list.length ? getYMDHMS(new Date().getTime()) : ''
          //       }
          //     }, this.delay)
          //   }
          // }
        },
      });
      this.$store.dispatch("form/handle", {
        url:
          "/msglog/messageLog/realTimeDataMap/electric?startChargeSeq=" + this.num,
        method: "get",
        callback: (resp) => {
          resp.forEach((item) => {
            this.Exdata.push(item.time)
            this.Eydata1.push(item.electricReq)
            this.Eydata2.push(item.electricOutPut)
          });
          this.echartsE();
        },
      });
      this.$store.dispatch("form/handle", {
        url:
          "/msglog/messageLog/realTimeDataMap/gunLineTemp?startChargeSeq=" + this.num,
        method: "get",
        callback: (resp) => {
          resp.forEach((item) => {
            this.Txdata.push(item.time)
            this.Tydata.push(item.gunLineTemp)
          });
          this.echartsT();
        },
      });
    },
    // 第二次获取当前订单数据，传的是开始时间，每次请求接口记录一下当前的时间，然后再加
    // getSecondData(that) {
    //   const data = {
    //     pageSize: 2147483647,
    //     // pageNo: this.pageNo,
    //     msgType: 17,
    //     orderNo: this.orderNum ? this.orderNum : this.$route.query.num,
    //     loading: false,
    //     startTime: this.timestamp,
    //     orderType: 1
    //   }
    //   this.$store.dispatch('form/handle', {
    //     url: '/logs/logs/page',
    //     data: data,
    //     data1: true,
    //     method: 'get',
    //     callback: resp => {
    //       let data = null
    //       // 如果为2则是直流
    //       if (this.type === 2) {
    //         data = this.getDirectData(resp)
    //         // 循环添加数据
    //         for (let i = 0; i < resp.list.length; i++) {
    //           that.echartsVSource[0].push(JSON.parse(JSON.stringify(data.time[i])))
    //           that.echartsVSource[1].push(JSON.parse(JSON.stringify(data.demandVoltage[i])))
    //           that.echartsVSource[2].push(JSON.parse(JSON.stringify(data.currentVoltage[i])))

    //           that.echartsESource[0].push(JSON.parse(JSON.stringify(data.time[i])))
    //           that.echartsESource[1].push(JSON.parse(JSON.stringify(data.demandEleCurrent[i])))
    //           that.echartsESource[2].push(JSON.parse(JSON.stringify(data.currentEleCurrent[i])))

    //           that.echartsTSource[0].push(JSON.parse(JSON.stringify(data.time[i])))
    //           that.echartsTSource[1].push(JSON.parse(JSON.stringify(data.gunLineTem[i])))
    //         }
    //       } else {
    //         data = this.getInterflowData(resp)
    //         // 循环添加数据
    //         for (let i = 0; i < resp.list.length; i++) {
    //           that.echartsVSource[0].push(JSON.parse(JSON.stringify(data.time[i])))
    //           that.echartsVSource[1].push(JSON.parse(JSON.stringify(data.demandVoltage[i])))

    //           that.echartsESource[0].push(JSON.parse(JSON.stringify(data.time[i])))
    //           that.echartsESource[1].push(JSON.parse(JSON.stringify(data.demandEleCurrent[i])))

    //           that.echartsTSource[0].push(JSON.parse(JSON.stringify(data.time[i])))
    //           that.echartsTSource[1].push(JSON.parse(JSON.stringify(data.gunLineTem[i])))
    //         }
    //       }
    //       // 如果有数据的话就给个当前时间戳
    //       that.timestamp = resp.list.length ? getYMDHMS(new Date().getTime()) : ''
    //       if (resp.list.length !== 0) {
    //         that.echartsV()
    //         that.echartsE()
    //         that.echartsT()
    //       }
    //     }
    //   })
    // },
    // // 获取直流桩的数据
    // getDirectData(resp) {
    //   // 获取X轴时间数据
    //   const time = resp.list.map(item => {
    //     return getYMDHMS(item.time).slice(11)
    //   })
    //   // 获取需求电压数据，因为目前的数据都是0，所以加了个随机数
    //   const demandVoltage = resp.list.map(item => {
    //     return Number(item['输出电压']) // + Math.round(Math.random() * 10)
    //   })
    //   // 获取实际电压数据，目前没有，所以用随机数
    //   const currentVoltage = resp.list.map(item => {
    //     return Math.round(Math.random() * 10)
    //   })
    //   // 获取需求电流数据，因为目前的数据都是0，所以加了个随机数
    //   const demandEleCurrent = resp.list.map(item => {
    //     return Number(item['输出电流']) // + Math.round(Math.random() * 10)
    //   })
    //   // 获取实际电流数据，目前没有，所以用随机数
    //   const currentEleCurrent = resp.list.map(item => {
    //     return Math.round(Math.random() * 10)
    //   })
    //   // 枪线温度
    //   const gunLineTem = resp.list.map(item => {
    //     return Number(item['枪线温度']) + Math.round(Math.random() * 10)
    //   })
    //   return {
    //     time: time, // 时间
    //     demandVoltage: demandVoltage, // 需求电压
    //     currentVoltage: currentVoltage, // 实际电压
    //     demandEleCurrent: demandEleCurrent, // 需求电流
    //     currentEleCurrent: currentEleCurrent, // 实际电流
    //     gunLineTem: gunLineTem // 枪线温度
    //   }
    // },
    // // 获取交流桩的数据
    // getInterflowData(resp) {
    //   // 获取X轴时间数据
    //   const time = resp.list.map(item => {
    //     return getYMDHMS(item.time).slice(11)
    //   })
    //   // 获取输出电压数据
    //   const demandVoltage = resp.list.map(item => {
    //     return Number(item['输出电压']) // + Math.round(Math.random() * 10)
    //   })
    //   // 获取输出电流数据
    //   const demandEleCurrent = resp.list.map(item => {
    //     return Number(item['输出电流']) // + Math.round(Math.random() * 10)
    //   })
    //   // 枪线温度
    //   const gunLineTem = resp.list.map(item => {
    //     return Number(item['枪线温度']) + Math.round(Math.random() * 10)
    //   })
    //   return {
    //     time: time, // 时间
    //     demandVoltage: demandVoltage, // 输出电压
    //     demandEleCurrent: demandEleCurrent, // 输出电流
    //     gunLineTem: gunLineTem // 枪线温度
    //   }
    // },
    // 需求/输出电压的图表配置
    echartsV() {
      var myChart = this.$echarts.init(document.getElementById("echartsV"));

      const option1 = {
        color: ["#FF8800", "#009FCC"],
        title: {
          text: "需求/输出电压",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["需求电压", "实际电压"],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        dataset: {
          source: this.echartsVSource,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          axisTick: {
            show: false,
          },
          axisLabel: {
            rotate: 40,
          },
          data: this.Vxdata
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            name: "需求电压",
            type: "line",
            seriesLayoutBy: 'row',
            data: this.Vydata1
          },
          {
            name: "实际电压",
            type: "line",
            seriesLayoutBy: 'row',
            data: this.Vydata2
          },
        ],
      };
      myChart.setOption(option1);
    },
    // 需求/输出电流的图表配置
    echartsE() {
      var myChart = this.$echarts.init(document.getElementById("echartsE"));
      const option = {
        color: ["#FF8800", "#009FCC"],
        title: {
          text: "需求/输出电流",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["需求电流", "实际电流"],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        dataset: {
          source: this.echartsESource,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          axisTick: {
            show: false,
          },
          axisLabel: {
            rotate: 40,
          },
          data: this.Exdata
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            name: "需求电流",
            type: "line",
            seriesLayoutBy: "row",
            data: this.Eydata1
          },
          {
            name: "实际电流",
            type: "line",
            seriesLayoutBy: "row",
            data: this.Eydata2
          },
        ],
      };
      myChart.setOption(option);
    },
    // 枪线温度的图表配置
    echartsT() {
      var myChart = this.$echarts.init(document.getElementById("echartsT"));
      const option = {
        color: ["#FF8800", "#009FCC"],
        title: {
          text: "枪线温度",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["枪线温度"],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        dataset: {
          source: this.echartsTSource,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          axisTick: {
            show: false,
          },
          axisLabel: {
            rotate: 40,
          },
          data: this.Txdata
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            type: "line",
            seriesLayoutBy: "row",
            data: this.Tydata
          },
        ],
      };
      myChart.setOption(option);
    },
  },
};
</script>

<style scoped lang="less">
.echarts {
  height: 250px;
  width: 85vw;
}

.border {
  border: 1px solid #928686;
  border-radius: 5px;
  // width: 100%;
}

.mt-30 {
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/orderManagement/components/real-time-chart.vue